<template>
  <div class="container">
    <div ref="vertList">
      <template v-for="(searchResult, index) in searchResults" :key="searchResult.cursor">
        <div>
          <SitterCard
            :sitter-id-for-profile="searchResult.sitterIdForProfile"
            :distance="searchResult.distance"
            :description="searchResult.description"
            :min-rate="searchResult.minRate"
            :max-rate="searchResult.maxRate"
            :name="searchResult.name"
            :photo-url="searchResult.photoUrl"
            :years-experience="searchResult.yearsExperience"
            :informal-years-experience="searchResult.informalYearsExperience"
            :avg-rating="searchResult.avgRating"
            :total-ratings="searchResult.totalRatings"
            :idv="searchResult.idv"
            :badges="searchResult.badges"
            :caretype="caretypeForSitter(caretype, searchResult.sitter)"
            custom-classes="w-full mb-20"
            :availability="searchResult.availability"
            :city="searchResult.city"
            :state-abbr="searchResult.stateAbbr"
            :is-recruited="isRecruited(searchResult.sitterIdForProfile)"
            :account="account"
            :show-invite-button="showInviteButton"
            :search-care-type="searchCareType"
            :parent-jobs="parentJobs"
            target="_blank"
            @sitter-recruited="handleSitterRecruited"
          />
          <BHPartnersList v-if="showExtraContent(index)" :key="index" :show-header="false" :zip-code="zip" />
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from 'vue';
import SitterCard from '@/components/sitter_card/SitterCard.vue';
import BHPartnersList from '@/components/bh_partners/BHPartnersList.vue';
import { Account } from '@/models/account';
import { JobEdge } from '@/graphql/messages/queries';

export default {
  name: 'SearchList',
  components: {
    SitterCard,
    BHPartnersList,
  },
  props: {
    searchResults: {
      required: true,
      type: Array,
    },
    caretype: {
      required: true,
      type: String,
    },
    zip: {
      type: String,
      required: true,
    },
    showBHPartners: {
      type: Boolean,
      default: true,
    },
    availabilityChecks: {
      type: Array,
      default: () => [],
    },
    account: {
      type: Object as PropType<Account | null>,
      default: null,
    },
    showInviteButton: {
      type: Boolean,
      default: false,
    },
    searchCareType: {
      type: String,
      default: 'babysitter',
    },
    parentJobs: {
      type: Array as PropType<JobEdge[]>,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  data(): any {
    return {
      recruitedSitters: new Set(),
    };
  },
  methods: {
    isRecruited(sitterUuid: string) {
      return this.availabilityChecks?.includes(sitterUuid);
    },
    handleSitterRecruited(sitterUuid: string | null) {
      this.$emit('sitterRecruited', sitterUuid);
    },
    showExtraContent(index: number): boolean {
      if (!this.showBHPartners || this.currentPage !== 1) return false;
      return index === 4 || (this.searchResults.length < 5 && index === this.searchResults.length - 1);
    },
    // Both and childcare searches return babysitter and nanny profiles,
    // so we need to determine the correct caretype to display based on the sitter's profiles status
    caretypeForSitter(careType: string, sitter: any) {
      if (careType === 'nanny') {
        return sitter.nannyProfileVisible && sitter.nannyProfileCompleted ? 'nanny' : 'babysitter';
      }
      if (['babysitter', 'childcare', 'both'].includes(careType)) {
        return sitter.babysitterProfileVisible && sitter.babysitterProfileCompleted ? 'babysitter' : 'nanny';
      }
      return 'babysitter';
    },
  },
};
</script>
